<script setup lang="ts">
import { email, emailLink } from 'src/data/contacts';
</script>

<template lang="pug">
a.email-link(:href="emailLink").no-underline.text-size-24px.lg-text-size-28px
  | {{ email }}
</template>
